import { DAW, type DAWInfo } from '@/common/models/DAWs';

const importedTypes: Record<string, keyof typeof DAW> = {
  ableton: 'ableton-live',
  flstudio: 'fl-studio',
  logic: 'logic-pro',
  protools: 'pro-tools',
  cubase: 'cubase',
  reaper: 'reaper',
};

// Normalize only exact importer-generated descriptions, never custom notes.
export function projectCardDetails(description: string | null | undefined) {
  const match = description?.trim().match(/^(\w+) project with (\d+) files?$/i);
  if (!match)
    return { label: 'Project', note: description || '', icon: undefined };
  const key = match[1].toLowerCase();
  const daw: DAWInfo | undefined = importedTypes[key]
    ? DAW[importedTypes[key]]
    : undefined;
  const type = daw?.name ?? (key === 'stems' ? 'Stems' : 'Project');
  const count = Number(match[2]);
  return {
    label: `${type} · ${count.toLocaleString()} ${count === 1 ? 'file' : 'files'}`,
    note: '',
    icon: daw?.icon.icon,
  };
}

export function projectCardUpdated(value: string, now = Date.now()) {
  const date = new Date(value);
  if (!Number.isFinite(date.getTime())) return 'Update date unavailable';
  const days = Math.max(0, Math.floor((now - date.getTime()) / 86_400_000));
  if (days === 0) return 'Updated today';
  if (days === 1) return 'Updated yesterday';
  if (days < 7) return `Updated ${days}d ago`;
  return `Updated ${date.toLocaleDateString(undefined, { month: 'short', day: 'numeric', ...(date.getFullYear() !== new Date(now).getFullYear() ? { year: 'numeric' } : {}) })}`;
}
